import { render, staticRenderFns } from "./MoRegisterPage.vue?vue&type=template&id=729d02d8&scoped=true&"
import script from "./MoRegisterPage.vue?vue&type=script&lang=js&"
export * from "./MoRegisterPage.vue?vue&type=script&lang=js&"
import style0 from "./MoRegisterPage.vue?vue&type=style&index=0&id=729d02d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729d02d8",
  null
  
)

export default component.exports